import * as Request from "common/utils/serverRequest";
import * as serverPaths from "common/utils/serverPaths";
//-------------------------------------------------------------------------------------------------------------------------------
// Login
//-------------------------------------------------------------------------------------------------------------------------------
export function async_Login(dispatch, dto) {
    return Request.
        postAuthComponentJson(dispatch, serverPaths.login(), dto)
        .then((response) => handleResponseSuccess(response), (error) => handleResponseFailure(error));
}
//-------------------------------------------------------------------------------------------------------------------------------
// Log out
//-------------------------------------------------------------------------------------------------------------------------------
export function async_logout(dispatch) {
    return Request.postAuthComponentJson(dispatch, serverPaths.logout(), {})
        .then((response) => handleResponseSuccess(response), (error) => handleResponseFailure(error));
}
//-------------------------------------------------------------------------------------------------------------------------------
// Verify
//-------------------------------------------------------------------------------------------------------------------------------
export function async_requestVerify(dispatch, dto) {
    return Request.postAuthComponentJson(dispatch, serverPaths.requestVerify(), dto)
        .then((response) => handleResponseSuccess(response), (error) => handleResponseFailure(error));
}
//-------------------------------------------------------------------------------------------------------------------------------
export function async_verify(dispatch, dto) {
    return Request.postAuthComponentJson(dispatch, serverPaths.verify(), dto)
        .then((response) => handleResponseSuccess(response), (error) => handleResponseFailure(error));
}
//-------------------------------------------------------------------------------------------------------------------------------
// Forgot
//-------------------------------------------------------------------------------------------------------------------------------
export function async_forgotPassword(dispatch, dto) {
    return Request.postAuthComponentJson(dispatch, serverPaths.forgotPassword(), dto)
        .then((response) => handleResponseSuccess(response), (error) => handleResponseFailure(error));
}
//-------------------------------------------------------------------------------------------------------------------------------
export function async_resetPassword(dispatch, dto) {
    return Request.postAuthComponentJson(dispatch, serverPaths.resetPassword(), dto)
        .then((response) => handleResponseSuccess(response), (error) => handleResponseFailure(error));
}
//-------------------------------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------------------------------
// Helpers
//-------------------------------------------------------------------------------------------------------------------------------
function handleResponseSuccess(response) {
    return response.json()
        .then((json) => {
        return Promise.resolve(json.message);
    }, () => {
        return Promise.reject("Unknown error interpreting response");
    });
}
function handleResponseFailure(error) {
    return Promise.reject(error.message);
}
//-------------------------------------------------------------------------------------------------------------------------------
class TokenEndpointErrorObject {
}
class ServerReturnObject {
}
